'use strict';
(() => {
  const updateOffset = () => {
    const header = document.querySelector('.jmo-product-header');
    if (!header) return;
    const section = header.closest('.shopify-section') || header;
    document.documentElement.style.setProperty('--header-panel-offset', `${Math.max(0, section.getBoundingClientRect().bottom)}px`);
  };
  const initialize = () => {
    document.querySelectorAll('.jmo-product-header').forEach(header => {
      if (header.dataset.productHeaderReady) return;
      header.dataset.productHeaderReady = 'true';
      header.querySelectorAll('[data-header-details]').forEach(details => {
        const summary = details.querySelector(':scope > summary');
        const sync = () => {
          summary?.setAttribute('aria-expanded', String(details.open));
          updateOffset();
        };
        sync();
        details.addEventListener('toggle', () => {
          sync();
          if (details.open && details.classList.contains('jmo-menu-details')) {
            details.querySelector('[data-close-details]')?.focus({ preventScroll: true });
          } else if (!details.open && details.contains(document.activeElement) && document.activeElement !== summary) {
            summary?.focus({ preventScroll: true });
          }
        });
      });
    });
    updateOffset();
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('resize', updateOffset, { passive: true });
  window.addEventListener('scroll', () => {
    if (document.querySelector('.jmo-product-header [data-header-details][open]')) updateOffset();
  }, { passive: true });
})();
